import { render } from "./CreateDeviceModel.vue?vue&type=template&id=6b89c3c5"
import script from "./CreateDeviceModel.vue?vue&type=script&lang=js"
export * from "./CreateDeviceModel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__